module.exports = __webpack_public_path__ + "media/images/site/32x32-c05bb45deaa22bab793385e02d7a3c6a.png";